export enum eBrandColor {
  xxdark = "#00404E",
  xdark = "#00586C",
  dark = "#006A83",
  standard = "#007E94",
  light = "#48ABBE",
  xlight = "#91D1DF",
  xxlight = "#D9F1F6",
}

export enum eGreyColor {
  black = "#000000",
  xxdark = "#262626",
  xdark = "#484848",
  dark = "#808080",
  standard = "#A1A1A1",
  light = "#E5E5E5",
  xlight = "#F0F0F0",
  xxlight = "#F8F8F8",
  white = "#FFFFFF",
}

export enum eDangerColor {
  xxdark = "#B53329",
  xdark = "#CF3B2F",
  dark = "#E84234",
  standard = "#FF493A",
  light = "#FF8178",
  xlight = "#FFB8B3",
  xxlight = "#FFE3E1",
}

export enum eAlertColor {
  xxdark = "#B38800",
  xdark = "#C49B00",
  dark = "#E1B800",
  standard = "#FFD600",
  light = "#FFE77B",
  xlight = "#FFEFA7",
  xxlight = "#FFFAD9",
}

export enum eSuccessColor {
  xxdark = "#357F52",
  xdark = "#42A268",
  dark = "#4FBF7C",
  standard = "#57D48A",
  light = "#8FE3B1",
  xlight = "#b1edc8",
  xxlight = "#e6faec",
}

export enum eMermaidColor {
  xxdark = "#128072",
  xdark = "#19A895",
  dark = "#1FBFAA",
  standard = "#26D5BE",
  light = "#64E1D0",
  xlight = "#A1EDE3",
  xxlight = "#DFF9F5",
}

export enum eAquaColor {
  xxdark = "#2c7Da1",
  xdark = "#39A1CE",
  dark = "#3FB5E7",
  standard = "#46C9FF",
  light = "#82D9FF",
  xlight = "#B8E9FF",
  xxlight = "#DBF4FF",
}

export enum eSquidColor {
  xxdark = "#4E48B5",
  xdark = "#5a52CF",
  dark = "#655Ce9",
  standard = "#7066FF",
  light = "#8D8DFF",
  xlight = "#C6C3FF",
  xxlight = "#E3E1FF",
}

export enum eAnemoneColor {
  xxdark = "#B52952",
  xdark = "#CF2F5C",
  dark = "#E83568",
  standard = "#FF3B74",
  light = "#FF709A",
  xlight = "#FFA6BF",
  xxlight = "#FFD9E4",
}

export enum eStarfishColor {
  xxdark = "#A65200",
  xdark = "#C46100",
  dark = "#E16F00",
  standard = "#FF7E00",
  light = "#FFA556",
  xlight = "#FFBF87",
  xxlight = "#FFE6D0",
}

// IST 2024 Brand Guideline Colors (pages 17-23)

export enum ePetroleumColor {
  s900 = "#0D272F",
  s800 = "#10313B",
  s700 = "#143C48",
  s600 = "#174655",
  s500 = "#3A626F",
  s400 = "#5D7E88",
  s300 = "#7F99A2",
  s200 = "#A2B5BB",
  s100 = "#C5D1D5",
  s050 = "#E8EDEE",
}

export enum ePurple2024Color {
  s900 = "#33218C",
  s800 = "#402AB3",
  s700 = "#4E33D9",
  s600 = "#5C3CFF",
  s500 = "#7459FF",
  s400 = "#8D77FF",
  s300 = "#A594FF",
  s200 = "#BEB1FF",
  s100 = "#D6CEFF",
  s050 = "#EFECFF",
}

export enum eRed2024Color {
  s900 = "#8C2C17",
  s800 = "#B3381D",
  s700 = "#D94424",
  s600 = "#FF502A",
  s500 = "#FF6A4A",
  s400 = "#FF856A",
  s300 = "#FF9F8A",
  s200 = "#FFB9AA",
  s100 = "#FFD3CA",
  s050 = "#FFEEEA",
}

export enum eYellow2024Color {
  s900 = "#8C7738",
  s800 = "#B39847",
  s700 = "#D9B857",
  s600 = "#FFD966",
  s500 = "#FFDF7D",
  s400 = "#FFE494",
  s300 = "#FFEAAB",
  s200 = "#FFF0C2",
  s100 = "#FFF6D9",
  s050 = "#FFFBF0",
}

export enum eGreen2024Color {
  s900 = "#15793F",
  s800 = "#1B9A51",
  s700 = "#21BB62",
  s600 = "#27DC73",
  s500 = "#47E188",
  s400 = "#68E79D",
  s300 = "#88ECB2",
  s200 = "#A9F1C7",
  s100 = "#C9F6DC",
  s050 = "#E9FCF1",
}

export enum ePinkColor {
  s900 = "#8A1641",
  s800 = "#AF1C53",
  s700 = "#D52265",
  s600 = "#FA2877",
  s500 = "#FB488B",
  s400 = "#FC69A0",
  s300 = "#FC89B4",
  s200 = "#FDA9C9",
  s100 = "#FEC9DD",
  s050 = "#FFEAF1",
}

// Turn enum into array
function ToArray(enumme) {
  return Object.keys(enumme).map((key) => enumme[key]);
}

const ColorMixin = {
  methods: {
    brandcolors(): string[] {
      return ToArray(eBrandColor);
    },

    greycolors(): string[] {
      return ToArray(eGreyColor);
    },

    dangercolors(): string[] {
      return ToArray(eDangerColor);
    },

    alertcolors(): string[] {
      return ToArray(eAlertColor);
    },

    successcolors(): string[] {
      return ToArray(eSuccessColor);
    },

    mermaidColors(): string[] {
      return ToArray(eMermaidColor);
    },

    aquaColors(): string[] {
      return ToArray(eAquaColor);
    },

    squidColors(): string[] {
      return ToArray(eSquidColor);
    },

    anemoneColors(): string[] {
      return ToArray(eAnemoneColor);
    },
    starfishColors(): string[] {
      return ToArray(eStarfishColor);
    },

    petroleumColors(): string[] {
      return ToArray(ePetroleumColor);
    },

    purple2024Colors(): string[] {
      return ToArray(ePurple2024Color);
    },

    red2024Colors(): string[] {
      return ToArray(eRed2024Color);
    },

    yellow2024Colors(): string[] {
      return ToArray(eYellow2024Color);
    },

    green2024Colors(): string[] {
      return ToArray(eGreen2024Color);
    },

    pinkColors(): string[] {
      return ToArray(ePinkColor);
    },

    getAllISTcolors() {
      return [
        ...this.brandcolors(),
        ...this.dangercolors(),
        ...this.alertcolors(),
        ...this.successcolors(),
        ...this.mermaidColors(),
        ...this.aquaColors(),
        ...this.squidColors(),
        ...this.anemoneColors(),
        ...this.starfishColors(),
        ...this.greycolors(),
      ];
    },
  },
};
export default ColorMixin;
